"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { useEditorState } from "@tiptap/react";
import { LuList } from "react-icons/lu";
import { Button } from "@/components/ui";
export function BulletListButton() {
  const $ = _c(8);
  const {
    editor
  } = useEmailComposer();
  let t0;
  if ($[0] !== editor) {
    t0 = {
      editor,
      selector: _temp
    };
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isActive = useEditorState(t0);
  let t1;
  if ($[2] !== editor) {
    t1 = () => {
      editor?.chain().focus().toggleBulletList().run();
      trackEmailComposerAction("bullet_list_toggled", "toolbar");
    };
    $[2] = editor;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isActive ? "bg-hover" : "";
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LuList size={15} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <Button type="button" variant="ghost" size="icon-sm" onClick={t1} className={t2} tooltip="Bullet list">{t3}</Button>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(ctx) {
  return ctx.editor?.isActive("bulletList") ?? false;
}